module.exports = __webpack_public_path__ + "img/brown-wooden-base-ceramic-washcloset-3258310.8c306a99.jpg";